import store from "../storeWire";
import {
  alternative_product_by_variant_number_list,
  product_document_list,
  product_images_list,
  alternative_products_count,
  clearAlternativeProductData,
  check_designs,
  get_Product_Manufacture_External_Heading
} from "../store/slice/model/ProductDetail";
import { useSelector } from "react-redux";
import { set_product_master_data, getProductList } from "../store/slice/model/ProductListing";
import ProductRepository from "src/repository/ProductRepository";
import { isEqual } from "underscore";
import ProductDetailAPICall from "../service/ProductDetailAPICall";
import { removeAllData } from "src/store/slice/model/ProductCompare";
import ProductCompareRepository from "../repository/ProductCompareRepository";
import { __remove, __set } from "src/store/axios_indicator";

export function useProductStore() {
  const productList = useSelector((state) => state.entities.model_ProductListing.master_data_only_products_list, isEqual)
  const append_facade_options_status = useSelector((state) => state.entities.model_ProductListing.append_facade_options_status)
  const productListWithFacet = useSelector((state) => state.entities.model_ProductListing.productListWithFacet) // use this for product list
  const product_document_data = useSelector((state) => state.entities.model_ProductDetail.documentData)
  const product_images_data = useSelector((state) => state.entities.model_ProductDetail.imagesData)
  const alternative_product_data = useSelector((state) => state.entities.model_ProductDetail.alternativeProductData)
  const alternative_product_count = useSelector((state) => state.entities.model_ProductDetail.alternativeProductCount)
  const designHubData = useSelector((state) => state.entities.model_ProductDetail.designHubData.data)
  const model_ProductCompare_data = useSelector((state) => state.entities.model_ProductCompare.data, isEqual);
  const compact_expander = useSelector((state) => state.entities.ProductListingSettings.compact_expander)
  const productHeadingData = useSelector((state) => state.entities.model_ProductDetail.productHeadingData)

  const data = {
    append_facade_options_status,
    productListWithFacet,
    product_document_data,
    alternative_product_data,
    alternative_product_count,
    product_images_data,
    productList,
    designHubData,
    model_ProductCompare_data,
    compact_expander,
    productHeadingData
  };

  const fetch = {
    fetch_product_category_list: async () => {
      return await new ProductDetailAPICall().getProductCategory();
    },

    check_designs: async (params) => {
      return await store.dispatch(check_designs(params))
    },

    get_product_category_external_search: async (params) => {
      return await new ProductDetailAPICall().getProductManufactureExternalSearch(params.requestUrl)
    },
    get_product_category_external_heading: async (params) => {
      return await store.dispatch(get_Product_Manufacture_External_Heading(params))
    },
    get_all_design_data: async (params) => {
      return await new ProductDetailAPICall().getAllDesignsData(params.itemNumberArray)
    },

    fetch_product_document_list: async (params) => {
      return await store.dispatch(product_document_list(params))
    },

    fetch_product_images_list: async (params) => {
      return await store.dispatch(product_images_list(params))
    },

    fetch_alternative_product_by_variant_number_list: async (params) => {
      __set('Bom_Alternative_API_CALL')
      const p = await store.dispatch(alternative_product_by_variant_number_list(params))
      await store.dispatch(set_product_master_data(p.payload));
      __remove('Bom_Alternative_API_CALL')
      return p.payload;
    },
    get_product_list: async (page, limit, extra) => {
      return await store.dispatch(getProductList({ page, limit, extra }))
    },
    fetch_alternative_product_count: async (params) => {
      return await store.dispatch(alternative_products_count(params))
    },
    get_universal_product_search_list: async (params) => {
      return await new ProductRepository().getUniversalProductSearchList(params);
    },
    get_universal_category_manufacturers_search_list: async (params) => {
      return await new ProductRepository().getUniversalCategoryManufacturersSearchList(params);
    },
    get_document_list: async (params, isAutoSearch = false) => {
      return await new ProductRepository().getDocumentList(params, isAutoSearch);
    },
    toggle_Single_Product: async (data) => {
      return await new ProductCompareRepository().toggleSingleProduct(data);
    },
    fetch_All_Data: async () => {
      return await new ProductCompareRepository().fetchAllData();
    },
    remove_All_Data: async () => {
      return await store.dispatch(removeAllData());
    },
    get_product_pricing_inventory: async (inputObj, extraParams = {}) => {
      return await new ProductRepository().getProductPriceInventoryAssets(inputObj, extraParams);
    },
    get_product_assets: async (inputObj, extraParams = {}) => {
      return await new ProductRepository().getProductAssets(inputObj, extraParams);
    },
    get_product_detail: async (params) => {
      return await new ProductRepository().getProductListById(params)
    },
    send_Report_Error_Email: async (params) => {
      return await new ProductRepository().sendReportErrorEmail(params)
    },
    fetch_GroupedProducts_ObjectBy_SearchParam: async (search, ManufacturerName, ERPPartNumbers, onlyGroup) => {
      return await new ProductRepository().fetchGroupedProductsObjectBySearchParam(search, ManufacturerName, ERPPartNumbers, onlyGroup)
    },
    get_CPN_AvailableIn_List: async (cpnList, searchCPN) => {
      return await new ProductRepository().getCPNAvailableInList(cpnList, searchCPN)
    },
    get_farnel_element_stock: async (prams) => {
      return await new ProductRepository().getFarnelElementStock(prams)
    },
  };
  const set = {
    clear_alternative_product_data: () => {
      return store.dispatch(clearAlternativeProductData())
    }
  };
  const operations = {
    optionsAvailable: () => {
      if (!(productListWithFacet && productListWithFacet?.searchFacets)) {
        return;
      }

      function checkOptionsAvailableFromAPI(facetName) {
        return productListWithFacet?.searchFacets && productListWithFacet?.searchFacets[facetName];
      }

      const LinkedWithSystem = {};
      if (Object.entries(productListWithFacet?.searchFacets).length > 0) {
        Object.entries(productListWithFacet?.searchFacets).map((v, i) => {
          LinkedWithSystem[v[1].slug] = {
            slug: v[1].slug,
            main_label: v[1].main_label
          };
        });
      }
      Object.entries(LinkedWithSystem).map((v, i) => {
        if (v[1].slug === 'FamilyName') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (v[1].slug === 'Categories') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (v[1].slug === 'ManufacturerName') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (v[1].main_label === 'Attributes') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (v[1].slug === 'FlagFacets') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (v[1].slug === 'flagFacets') {
          delete LinkedWithSystem[v[1].slug];
        }
        if (!checkOptionsAvailableFromAPI(v[1].slug)) {
          delete LinkedWithSystem[v[1].slug];
        }
      });

      return LinkedWithSystem;
    }
  };

  return [data, fetch, set, operations]
}